import { Route, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { shipmentRoutes } from './shipment/shipment.routes';
import { locationRoutes } from './location/location.routes';
import { DashboardComponent } from './dashboard/dashboard.component';
import { accountsRoutes } from './accounts/accounts.routes';
import { contractRoutes } from "./contracts/contracts.routes";
import { companyRoutes } from "./company/company.routes";
import { customerRoutes } from "./customer/customer.routes";
import { aiChatRoutes } from "./ai-chat/ai-chat.routes";
import { chartOfAccountRoutes } from "./chart-of-accounts/chart-of-accounts.routes";
import { expenseRoutes } from "./expense/expense.routes";
import { partyRoutes } from "./party/party.routes";
import { containerTrackingRoutes } from './container-tracking/container-tracking.routes';
import { orderRoutes } from './order/order.routes';
import { fleetRoutes } from './fleet/fleet.routes';
import { clearanceRoutes } from './clearance/clearance.routes';
import { flexFieldRoutes } from './flex-fields/flex-fields.routes';
import { posmRoutes } from './posm/posm.routes';
import { crmRoutes } from './crm/crm.routes';
import { warehousingRoutes } from './warehousing/warehousing.routes';
import { workflowRoutes } from './workflow/workflow.routes';
import { productivityRoutes } from './productivity/productivity.routes';
import { transportPlanningRoutes } from './transport-planning/transport-planning.routes';
import { onboardingRoutes } from './onboarding/onboarding.routes';
import { reportingRoutes } from './reporting/reporting.routes';
import { wasenderRoutes } from './wasender/wasender.routes';
import { fuelManagementRoutes } from './fuel-management/fuel-management.routes';
import { businessEventRoutes } from './business-events/business-events.routes';
import { auditRoutes } from './audit/audit.routes';
import { developerPlatformRoutes } from './developer-platform/developer-platform.routes';
import { hrRoutes } from './hr/hr.routes';
import { logisticsProjectRoutes } from './logistics-projects/logistics-projects.routes';
import { helpCenterRoutes } from './help-center/help-center.routes';
import { myHrRoutes } from './workspace/my-hr/my-hr.routes';
import { fieldWorkRoutes } from './field-work/field-work.routes';
import { PettyCashCustodianComponent } from './workspace/petty-cash/petty-cash-custodian.component';
import { PettyCashVoucherComponent } from './workspace/petty-cash/petty-cash-voucher.component';
import { PermissionGuard } from './security/permission.guard';
import { app_permissions } from './security/app-permissions';

const dashboardRoute: Route = { path: 'dashboard', component: DashboardComponent };
const loginRoute: Route = { path: 'login', component: LoginComponent };
const rootRoute: Route = { path: '', pathMatch: 'full', redirectTo: 'dashboard' };
const fallbackRoute: Route = { path: '**', redirectTo: 'dashboard' };

export const routes: Routes = [rootRoute, dashboardRoute, loginRoute, ...shipmentRoutes,
  { path: 'workspace/petty-cash', component: PettyCashCustodianComponent, canActivate: [PermissionGuard],
    data: { permission: app_permissions.workspace.petty_cash.view } },
  { path: 'workspace/petty-cash/vouchers/:id', component: PettyCashVoucherComponent, canActivate: [PermissionGuard],
    data: { permission: [app_permissions.workspace.petty_cash.view, app_permissions.accounts.petty_cash.boxes_manage,
      app_permissions.accounts.workforce_finance.recoveries_confirm] } },
  ...locationRoutes, ...accountsRoutes, ...contractRoutes, ...customerRoutes,
  ...companyRoutes, ...aiChatRoutes, ...chartOfAccountRoutes, ...orderRoutes,
  ...fleetRoutes, ...clearanceRoutes, ...flexFieldRoutes,
  ...expenseRoutes, ...partyRoutes, ...containerTrackingRoutes, ...posmRoutes,
  ...crmRoutes, ...warehousingRoutes, ...workflowRoutes, ...productivityRoutes,
  ...transportPlanningRoutes, ...onboardingRoutes, ...reportingRoutes, ...wasenderRoutes,
  ...businessEventRoutes, ...fuelManagementRoutes, ...auditRoutes, ...developerPlatformRoutes, ...hrRoutes,
  ...myHrRoutes, ...logisticsProjectRoutes, ...fieldWorkRoutes, ...helpCenterRoutes, fallbackRoute];
